export default __webpack_public_path__ + "static/media/Header Backgoround.9387bca4.png";